import { useRef, useState } from "react";
//--------------------------------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import {
    getDatefromWeekNum0, 
    myAxios, MyFormData, 
    scroll, 
    potholingReportWriterEmails
} from "src/components/common/functions";
import ReportForm from "./reportForm";

const title = "Reports";
//--------------------------------------------------------------------------------------------
export default function Detail({
    curWeekStart, 
    curWeekEnd, 
    setUserList, 
    report, 
    history, 
    deleteUser, 
    restoreUser, 
    notify, 
    editUser, 
    id, 
    idid, 
    usersList, 
    projectsList,
    reportWriterList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const receiptUploadRef = useRef(null);
    //--------------------------------------------------------------------------------------------
    const [comments, setComments] = useState(report.approverNotes || "");
    //--------------------------------------------------------------------------------------------
    return(
        
    <div className = "border text-left" style = {{borderRadius: "6px"}}>
        <form>
            <fieldset className = "border rounded p-3" style = {{minWidth: "800px", maxWidth: "90%", margin: "20px auto", whiteSpace: "pre-wrap"}}>
                <legend style = {{width: "auto", padding:"0px 10px"}}>Notes</legend>
                {report.notes}
            </fieldset>
            <fieldset className = "border rounded p-3" style = {{userSelect: "text", minWidth: "800px", maxWidth: "90%", margin: "20px auto", whiteSpace: "pre-wrap"}}>
                <legend style = {{width: "auto", padding:"0px 10px"}}>Report Local Path (for large file)</legend>
                {report.reportLocation}
            </fieldset>
        </form>
        <div className = "table-responsive" style = {{minWidth: "800px",maxWidth: "90%", margin: "20px auto"}}>
            <table className = "table">
                <colgroup>
                    <col/>
                </colgroup>
                    <tbody>
                        <tr>
                            <th>Update</th>
                            <th><UserInfo name = {report.updater} email = {report.updaterEmail}/> {!report.updateTime?"":report.updateTime}</th>
                        </tr>
                        
                        {!potholingReportWriterEmails.includes(report.reportTechEmail)?
                        <>
                        <tr>
                            <th>Finish</th>
                            <th><UserInfo name = {report.submitter} email = {report.submitterEmail}/> {!report.submitTime?"":report.submitTime}</th>
                        </tr>
                        </>
                        :
                        <>
                        <tr>
                            <th>Submit</th>
                            <th><UserInfo name = {report.submitter} email = {report.submitterEmail}/> {!report.submitTime?"":report.submitTime}</th>
                        </tr>
                        <tr>
                            <th>Approver</th>
                            <th><UserInfo name = {report.projectManager} email = {report.projectManagerEmail}/> {!report.decisionTime?"":report.decisionTime}</th>
                        </tr>
                        <tr>
                            <th>Approver Notes</th>
                            <th>{report.approverNotes}</th>
                        </tr>
                        {report.notify?
                        <tr>
                            <th>Notified At</th>
                            <th>{report.notify}</th>
                        </tr>
                        :<></>}
                        </>
                        }
                    </tbody>
                </table>
                </div>
        <input
            type = "file"
            ref = {receiptUploadRef}
            style = {{display:"none"}}
            onChange = {async e => {
                const target = e.currentTarget;
                const files = target.files;
                if(files.length === 1){
                    const formData = new MyFormData();
                    formData.append("reportHashKey", report.reportHashKey);
                    formData.append("pdf", files[0]);
                    formData.append("start", getDatefromWeekNum0(curWeekStart, 0).s());
                    formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).s());
                    //-------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("reports/addPDF.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------
                    setUserList(res.data);
                    history.replace(`/${title}`);
                    scroll(null);
                }
                target.value = "";
            }}
        />
        {!report.void?<>
        <div className = "m-3 text-right">
            {report.status === "Submitted"?<span className = "btn btn-success m-3" onClick = {notify} id = {report.reportHashKey}>Notify Approver</span>:<></>}
            {report.pdfId?<span className = "btn btn-info m-3" onClick = {() => {receiptUploadRef.current.click();}}>Update File</span>:<></>}
            <span className = "btn btn-success m-3" onClick = {editUser} id = {report.reportHashKey}>Edit Report</span>
            <span className = "btn btn-danger m-3" onClick = {deleteUser} id = {report.reportHashKey}>Void Report</span>
        </div>
        </>:<></>}
        {potholingReportWriterEmails.includes(report.reportTechEmail)?
        <>
        {report.projectManagerEmail === user.email?
        <div className = "mb-4">
            <div style = {{marginLeft: "5%", marginBottom: "10px"}}>Approval Notes</div>
            <textarea disabled = {report.status !== "Submitted"} className = "form-control" style = {{width:"90%", margin: "auto"}} value = {comments} onChange = {e => {setComments(e.currentTarget.value)}} name = "comments"/>
            <div>
                {report.status === "Submitted"?[
                    {title:"Approve", decision:"Approved", word: "approve", color: "btn-success"}, 
                    {title:"Reject", decision:"Rejected", word: "reject", color: "btn-danger"}
                ].map((d, di) => 
                <span key = {di} className = {`btn ${d.color} mx-3 mt-3`} onClick = {async() => {
                    if(!window.confirm(`Are you sure to ${d.word} this report?`)) return;
                    const formData = new MyFormData();
                    formData.append("reportHashKey", report.reportHashKey);
                    formData.append("approverDecision", d.decision);
                    formData.append("approverNotes", comments);
                    formData.append("start", getDatefromWeekNum0(curWeekStart, 0).s());
                    formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).s());
                    //-------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("reports/approval.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------
                    setUserList(res.data);
                }}>{d.title}</span>):<></>}
            </div>
        </div>
        :<div className = "mb-4">
            <div style = {{marginLeft: "5%", marginBottom: "10px"}}>Approval Notes</div>
            <textarea disabled className = "form-control" style = {{width:"90%", margin: "auto"}} value = {comments} name = "comments"/>
        </div>}
        </>:<></>}
        {report.void?<>
        <div className = "m-4 font-weight-bold h3">Void</div>
        <div className = "m-4"><span className = "h4 mr-3">Void Reason:</span>{report.voidReason}</div>
        <div className = "m-4"><span className = "btn btn-danger" onClick = {restoreUser} id = {report.reportHashKey}>Valid</span></div>
        </>:<></>}
        {idid === "Edit"?
        <ReportForm
            reportWriterList = {reportWriterList}
            curWeekStart = {curWeekStart} 
            curWeekEnd = {curWeekEnd} 
            setUserList = {setUserList} 
            history = {history}
            {...report} 
            id = {id}
            usersList = {usersList} 
            projectsList = {projectsList} 
            closeIt = {() => history.push(`/${title}/${id}`)}
            keyword = "Update"
        />:<></>}
    </div>
    )
}